<template>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-8">
        <div class="card">
          <div class="card-header">Moje Konto - REJESTRACJA</div>
          <div class="card-body text-center">
            <a :href="webLink" target="_blank">
              <img class="p-3" :src="logoSrc" alt="skp"
            /></a>
            <form v-if="!emailSent" @change="validateForm">
              <div class="form-group row">
                <label
                  for="licence"
                  class="col-md-4 col-form-label text-md-right"
                  >Nr licencji</label
                >
                <div class="col-md-5">
                  <input
                    id="licence"
                    type="number"
                    class="form-control"
                    name="licence"
                    required
                    autofocus
                    v-model="form.licence"
                  />
                  <div
                    v-if="validated && !validLicecnce"
                    class="text-danger small text-left"
                  >
                    Wpisz numer licencji.
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label
                  for="licence"
                  class="col-md-4 col-form-label text-md-right"
                  >NIP</label
                >
                <div class="col-md-5">
                  <input
                    id="nip"
                    @keydown="validateNip($event)"
                    class="form-control"
                    name="nip"
                    required
                    autofocus
                    v-model="form.nip"
                  />
                  <div
                    v-if="validated && !validNip"
                    class="text-danger small text-left"
                  >
                    Wpisz nip.
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label for="email" class="col-md-4 col-form-label text-md-right"
                  >E-mail</label
                >
                <div class="col-md-5">
                  <input
                    id="email"
                    type="email"
                    class="form-control"
                    name="email"
                    required
                    autocomplete="email"
                    v-model="form.email"
                  />
                  <div
                    v-if="validated && !validEmail"
                    class="text-danger small text-left"
                  >
                    Wpisz adres e-mail.
                  </div>
                </div>
              </div>
              <div class="form-group row mb-10 justify-content-md-center">
                <div class="col-md-7">
                  <p class="font-italic small mb-2">
                    Uwaga! Wpisany powyżej adres e-mail powinien być zgodny z
                    zapisanym w Twoich danych licencyjnych. Jeśli nie pamiętasz
                    bądź nie posiadasz zarejestrowanego adresu e-mail, wpisz
                    nowy, a my go przypiszemy do Twoich danych licencyjnych.
                  </p>
                </div>
                <div
                  v-if="showChangeEmailRequest"
                  class="mt-3 readonlyInput pt-2 pb-1 px-2 mb-2"
                >
                  <p>
                    <i class="fas fa-exclamation-circle"></i> Uwaga ! W naszej
                    bazie znajduje się inny adres e-mail przypisany do Twojej
                    licencji. <br />
                    Czy chcesz zmienić adres e-mail na nowy?
                  </p>
                  <b-form-radio-group
                    v-model="selected"
                    :options="options"
                    class="mb-3"
                    value-field="item"
                    text-field="name"
                    disabled-field="notEnabled"
                    @change="selectOption"
                  ></b-form-radio-group>
                </div>
                <div class="col-md-7 custom-control custom-checkbox mt-2">
                  <input
                    v-model="policy"
                    type="checkbox"
                    class="custom-control-input"
                    id="policy"
                  />
                  <label class="custom-control-label" for="policy"
                    >Akceptuję
                    <a :href="regulations" target="_blank">Regulamin Serwisu</a>
                    oraz
                    <a
                      href="https://docs.format.wroc.pl/Polityka_Prywatnosci_FORMSOFT.pdf"
                      target="_blank"
                      >Politykę Prywatności</a
                    ></label
                  >
                </div>
              </div>
              <p v-if="errors.length" class="error offset-md-2"></p>
              <ul>
                <li
                  v-for="error in errors"
                  v-bind:key="error"
                  class="text-danger justify-content-md-start"
                >
                  <span v-if="error == 'login'">
                    Użytkownik już istnieje. Przejdź do
                    <router-link
                      :to="{
                        name: 'Login',
                        props: { program: program },
                      }"
                      >strony logowania.</router-link
                    >
                  </span>
                  <span v-else v-html="error"></span>
                </li>
              </ul>
              <div
                v-if="changeEmailRequest"
                class="form-group row mb-10 justify-content-md-center"
              >
                <div class="col-md-6">
                  <button
                    v-on:click.prevent="validateUser"
                    class="btn btn-success btn-block my-2"
                  >
                    Wyślij
                  </button>
                </div>
              </div>
              <div
                v-else
                class="form-group row mb-10 justify-content-md-center"
              >
                <div class="col-md-6">
                  <button
                    v-on:click.prevent="sendEmail"
                    class="btn btn-success btn-block my-2"
                  >
                    Wyślij
                  </button>
                </div>
              </div>
              <div class="form-group row mb-10 justify-content-md-center">
                <div class="col-md-7">
                  <p>
                    Na podany adres e-mail otrzymasz wiadomość zawierającą link,
                    umożliwiający utworzenie hasła dostępu do Twojego konta.
                    <br />Kliknij go i wprowadź hasło do logowania.
                  </p>
                </div>
              </div>
            </form>
            <div class="success" v-if="emailSent">
              Twoja prośba o utworzenie hasła została wysłana. <br />Na podany
              adres e-mail otrzymasz wiadomość zawierającą link umożliwiający
              utworzenie hasła. <br />Kliknij go i utwórz nowe hasło.
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row justify-content-center">
      <img class="p-3 registerGraph" :src="registerGraph" alt="skp" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import axios from 'axios';
import { isTestAccountRegistered } from '../../shared/isTestAccountRegistered';

export default {
  name: 'Register',
  props: {
    logoSrc: {},
    registerGraph: {},
  },
  data() {
    return {
      form: {
        email: '',
        licence: '',
        nip: '',
      },
      errors: [],
      emailSent: false,
      text: '',
      policy: 0,
      userChecked: false,
      showChangeEmailRequest: false,
      changeEmailRequest: true,
      selected: null,
      options: [
        { item: 'yes', name: 'Tak' },
        { item: 'no', name: 'Nie, spróbuję wpisać jeszcze raz poprawny adres' },
      ],
      validated: false,
      validEmail: true,
      validNip: true,
      validLicecnce: true,
    };
  },
  computed: {
    ...mapGetters({
      program: 'getProgram',
    }),
    webLink() {
      return this.program === 'skp'
        ? 'https://www.ksiega-podatkowa.pl/'
        : 'https://www.samozatrudnienie.pl/';
    },
    regulations() {
      if (this.program === 'skp') {
        return 'https://docs.format.wroc.pl/skp/Regulamin_Serwisu_SKP_Moje_Konto.pdf';
      } else {
        return 'http://docs.format.wroc.pl/sam/Regulamin_Serwisu_SAM_Moje_Konto_18.05.2021.pdf';
      }
    },
    userable_type() {
      if (this.program === 'skp') {
        return isTestAccountRegistered(this.form.licence)
          ? 'App\\Models\\SkpClientTest'
          : 'App\\Models\\SkpClient';
      }

      return isTestAccountRegistered(this.form.licence)
        ? 'App\\Models\\SamClientTest'
        : 'App\\Models\\SamClient';
    },
  },
  beforeCreate: function () {
    document.body.className = 'login';
  },
  methods: {
    validateUser() {
      this.errors = [];
      this.validated = false;
      this.validateForm();

      if (this.validEmail && this.validNip && this.validLicecnce) {
        axios
          .post('/api/validateUser', {
            licence: this.form.licence,
            nip: this.parseNip(this.form.nip),
            email: this.form.email,
            program: this.program,
          })
          .then((response) => {
            if (response.data !== 'OK') {
              this.changeEmailRequest = true;
              this.showChangeEmailRequest = true;
            } else {
              this.changeEmailRequest = false;
              this.sendEmail();
            }
          })
          .catch((error) => {
            this.errors = [
              'Nie znaleziono użytkownika. Prawdopodobnie jedna z podanych danych jest niepoprawna. <br>Popraw i kliknij "Wyślij" ponownie.',
            ];
          });
      }
    },
    sendEmail() {
      this.errors = [];
      this.validated = false;
      this.validatePolicy();
      this.validateForm();

      if (
        this.errors.length === 0 &&
        this.validNip &&
        this.validLicecnce &&
        this.validEmail
      ) {
        axios
          .post('/register', {
            email: this.form.email,
            userable_id: this.form.licence,
            userable_type: this.userable_type,
            program: this.program,
            nip: this.parseNip(this.form.nip),
          })
          .then((response) => {
            this.emailSent = true;
          })
          .catch((error) => {
            this.errors = error.response.data.errors.email;
          });
      }
    },
    validatePolicy() {
      if (this.policy !== true) {
        this.errors = ['Zaakceptuj Regulamin i Politykę Prywatności.'];
      }
    },
    validateForm() {
      this.validLicecnce = !(
        this.form.licence === '' || this.form.licence === null
      );
      this.validNip = !(this.form.nip === '' || this.form.nip === null);
      this.validEmail = !(this.form.email === '' || this.form.email === null);
      this.validated = true;
    },
    parseNip(value) {
      return value.replace(/[\ \-]/gi, '');
    },
    selectOption() {
      if (this.selected === 'no') {
        this.showChangeEmailRequest = false;
        this.userChecked = false;
        this.form.email = '';
        this.selected = null;
      } else {
        this.changeEmailRequest = false;
      }
    },
    validateNip(e) {
      let regex = /^[0-9 \-]+$/;
      if (!regex.test(e.key) && e.keyCode !== 8) {
        e.preventDefault();
      }
    },
  },
};
</script>

<style scoped>
ul {
  list-style-type: none;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type='number'] {
  -moz-appearance: textfield;
}
</style>
